<template>
  <div class="carousel">
    <div
      class="carousel-track"
      :style="{ transform: `translateX(-${currentIndex * 100}%)`, transition: isTransition ? 'transform 0.5s ease-in-out' : 'none' }"
      @transitionend="handleTransitionEnd"
    >
      <div class="slide" v-for="(item, i) in slidesWithClone" :key="i">
        <img :src="item.img" :alt="item.title" />
        <div class="caption" :class="item.position">
          <div v-if="realIndex ==0">
            <div class="slidesFirstTitle">{{ $t('message.aboutCarouselSec01Title') }}</div>
            <div class="slidesFirstContent">
              <div>{{ $t('message.aboutCarouselSec01Hint2018_1') }}</div>
              <div>{{ $t('message.aboutCarouselSec01Hint2018_2') }}</div>
            </div>

            <div class="slidesFirstTimeLines">
              <div>{{ $t('message.aboutCarouselSec01Hint2021') }}</div>
              <div>{{ $t('message.aboutCarouselSec01Hint2022') }}</div>
              <div>{{ $t('message.aboutCarouselSec01Hint2023') }}</div>
              <div>{{ $t('message.aboutCarouselSec01Hint2024') }}</div>
              <div>{{ $t('message.aboutCarouselSec01Hint2025') }}</div>
            </div>
          </div>
          <div v-else>
            <h2>{{ item.title }}</h2>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="carousel-controls">
      <button class="prev" @click="prevSlide" @mouseenter="pauseAutoPlay" @mouseleave="startAutoPlay">
        <img src="@/assets/images/about/arrow-left.png" alt="Prev" />
      </button>
      <div class="dots">
        <span
          v-for="(item, i) in slides"
          :key="'dot-' + i"
          class="dot"
          :class="{ active: i === realIndex }"
          @click="goToSlide(i)"
          @mouseenter="pauseAutoPlay"
          @mouseleave="startAutoPlay"
        ></span>
      </div>
      <button class="next" @click="nextSlide" @mouseenter="pauseAutoPlay" @mouseleave="startAutoPlay">
        <img src="@/assets/images/about/arrow-right.png" alt="Next" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageCarousel',
  data() {
    return {
      slides: [
        { img: require('../assets/images/about/carouselBg.png'), title: '', desc: '', position: 'top-left' },
        {
          img: require('../assets/images/about/carouselBg1.png'),
          title: this.$t('message.aboutCarouselSec02Title'),
          desc: this.$t('message.aboutCarouselSec02Hint'),
          position: 'bottom-left'
        },
        {
          img: require('../assets/images/about/carouselBg2.png'),
          title: this.$t('message.aboutCarouselSec03Title'),
          desc: this.$t('message.aboutCarouselSec03Hint'),
          position: 'bottom-left'
        },
        {
          img: require('../assets/images/about/carouselBg3.png'),
          title: this.$t('message.aboutCarouselSec04Title'),
          desc: this.$t('message.aboutCarouselSec04Hint'),
          position: 'bottom-left'
        },
        // {
        //   img: require('../assets/images/about/carouselBg4.png'),
        //   title: this.$t('message.aboutCarouselSec05Title'),
        //   desc: this.$t('message.aboutCarouselSec05Hint'),
        //   position: 'bottom-left'
        // },
        {
          img: require('../assets/images/about/carouselBg5.png'),
          title: this.$t('message.aboutCarouselSec05Title'),
          desc: this.$t('message.aboutCarouselSec05Hint'),
          position: 'bottom-left'
        },
        {
          img: require('../assets/images/about/carouselBg6.png'),
          title: this.$t('message.aboutCarouselSec06Title'),
          desc: this.$t('message.aboutCarouselSec06Hint'),
          position: 'bottom-left'
        }
      ],
      currentIndex: 1, // 初始为 1，因为 0 是克隆的最后一张
      isTransition: true,
      autoPlayTimer: null,
      isAnimating: false // 动画锁，防止切换冲突
    }
  },
  computed: {
    slidesWithClone() {
      const last = this.slides[this.slides.length - 1]
      const first = this.slides[0]
      return [last, ...this.slides, first]
    },
    realIndex() {
      let idx = this.currentIndex - 1
      if (idx < 0) idx = this.slides.length - 1
      if (idx >= this.slides.length) idx = 0
      return idx
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.startAutoPlay()
    })
  },
  beforeDestroy() {
    this.pauseAutoPlay()
  },
  methods: {
    nextSlide() {
      if (this.isAnimating) return
      this.isTransition = true
      this.isAnimating = true
      this.currentIndex++
    },
    prevSlide() {
      if (this.isAnimating) return
      this.isTransition = true
      this.isAnimating = true
      this.currentIndex--
    },
    goToSlide(i) {
      if (this.isAnimating) return
      this.isTransition = true
      this.isAnimating = true
      this.currentIndex = i + 1
    },
    handleTransitionEnd() {
      this.isAnimating = false
      if (this.currentIndex === 0) {
        this.isTransition = false
        this.currentIndex = this.slides.length
      } else if (this.currentIndex === this.slides.length + 1) {
        this.isTransition = false
        this.currentIndex = 1
      }
    },
    startAutoPlay() {
      if (this.autoPlayTimer) return // 避免重复定时器
      this.autoPlayTimer = setInterval(() => {
        this.nextSlide()
      }, 1000000)
    },
    pauseAutoPlay() {
      clearInterval(this.autoPlayTimer)
      this.autoPlayTimer = null
    }
  }
}
</script>

<style scoped>
.carousel {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: black;
}
.carousel-track {
  display: flex;
  height: 100%;
}
.slide {
  min-width: 100%;
  position: relative;
}
.slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.caption {
  position: absolute;
  /* background: rgba(0, 0, 0, 0.5); */
  /* padding: 8px 12px; */
  border-radius: 6px;
  max-width: 70%;
}
.caption h2 {
  margin: 0 0 1.9rem;
  font-size: var(--title-font-size);
  font-weight: normal;
  color: #fff;
  font-weight: bold;
}
.caption p {
  margin: 10px 0px;
  color: #ddd;
  font-size: 1.2rem;
  line-height: 1.7rem;
  font-weight: 400;
}
.caption.top-left {
  top: 14vh;
  left: 6vw;
}
.slidesFirstTitle {
  color: #00a8ff;

  font-weight: bold;
  font-size: var(--title-font-size);
  text-align: left;
  line-height: 60px;
  font-style: normal;
  text-transform: none;
}
.slidesFirstContent {
  color: #aaa1a1;
  line-height: 26px;
  text-align: left;
  text-transform: none;
  margin-top: 1.9rem;
  font-size: 1.2rem;
  line-height: 1.7rem;
  font-weight: 400;
}
.slidesFirstTimeLines {
  color: #aaa1a1;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 26px;
  text-align: left;
  text-transform: none;
  margin-top: 1.9rem;
}

.caption.bottom-left {
  bottom: 10vh;
  left: 6vw;
}
.caption.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.carousel-controls {
  position: absolute;
  bottom: 4vh;
  left: 50%;
  transform: translateX(-50%);
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.carousel-controls button {
  background: transparent;
  border: none;
  cursor: pointer;
}
.carousel-controls button img {
  max-width: 14px;
  height: auto;
  display: block;
  transition: transform 0.2s;
}
.carousel-controls button:hover img {
  transform: scale(1.3);
}
@keyframes leftArrowSwing {
  0%,
  50%,
  100% {
    transform: translateX(0);
  }
  25%,
  75% {
    transform: translateX(-3px);
  }
}
@keyframes rightArrowSwing {
  0%,
  50%,
  100% {
    transform: translateX(0);
  }
  25%,
  75% {
    transform: translateX(3px);
  }
}
.carousel-controls .prev img {
  animation: leftArrowSwing 1.2s ease-in-out infinite;
}
.carousel-controls .next img {
  animation: rightArrowSwing 1.2s ease-in-out infinite;
}
.dots {
  display: flex;
  gap: 6px;
}
.dot {
  width: 8px;
  height: 8px;
  background: gray;
  border-radius: 50%;
  cursor: pointer;
}
.dot.active {
  background: white;
}

@media (max-width: 768px) {
  .caption {
    max-width: 90%;
    padding: 0px;
  }
  .caption.top-left {
    left: 5vw;
    top: 3rem;
  }
  .slidesFirstTitle {
    line-height: 2rem;
    font-size: 2rem;
  }
  .slidesFirstContent {
    margin-top: 1.5rem;
    line-height: 1.7rem;
  }
  .slidesFirstTimeLines {
    margin-top: 1.5rem;
    line-height: 1.7rem;
    /* word-break: break-all; */
  }
  .caption.bottom-left {
    left: 5vw;
    top: 21rem;
  }
  .caption h2 {
    margin: 0 0 1.5rem;
    font-size: 2rem;
    line-height: 2rem;
  }
  .carousel {
    height: 35.7rem;
  }
  .slide img {
    margin-top: -8rem;
  }
  .carousel-controls {
    bottom: 0rem;
  }
}
</style>
